import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OrderItem} from "../../../@services/gen/model/orderItem";
import {
  GetPagedOrderQuery, Merchant,
  OrderControllerService, OrderItemReq, OrderReq,
  TableMerchant,
  TableMerchantControllerService
} from "../../../@services/gen";
import * as dayjs from "dayjs";
import {UserShiftService} from "../../../@services/user-shift.service";
import {Order} from "../../../@services/gen/model/order";
import OrderStatusEnum = OrderItemReq.OrderStatusEnum;
import {Subject} from "rxjs";
import {printz} from "../../../@services/utils";
import {LocalstorageService} from "../../../@services/localstorage.service";
import {PaymentService} from "../../../@services/payment.service";

export interface ExtendedOrderItems extends OrderItemReq {
  selected: boolean;
  tempId: string;
  tempQty: number;
  order: OrderReq;
}

export interface ExtendedOrder extends OrderReq {
  toBePaidTotal: number;
  orderItems: ExtendedOrderItems[];
}

@Component({
  selector: "app-pos-split-bill-dialog",
  templateUrl: "./pos-customer-order-receipt-dialog.component.html",
  styleUrls: ["./pos-customer-order-receipt-dialog.component.scss"],
})
export class PosCustomerOrderReceiptDialogComponent {
  tableMerchant: TableMerchant;
  merchantId: number;
  merchant: Merchant = {};
  unpaidOrders: ExtendedOrder [];
  selectedRows: boolean[] = [];
  loadUnpaidOrders$: Subject<OrderReq[]> = new Subject<OrderReq[]>();


  constructor(private dialogRef: MatDialogRef<PosCustomerOrderReceiptDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: any, private orderService: OrderControllerService, private customUserShiftService: UserShiftService, private ls: LocalstorageService, private customPaymentService: PaymentService,) {
    this.tableMerchant = data.tableMerchant;
    this.merchantId = data.merchantId;
    this.merchant = this.ls.getMerchant();
    this.loadUnpaidOrders(data.tableMerchant);
  }

  private loadUnpaidOrders(table: TableMerchant) {
    let shiftStartDate = this.customUserShiftService.getUserShift().start;
    this.orderService
      .getPagedOrderPost({
        merchantId: this.merchantId,
        tableId: table.id,
        orderStatusEnum: [GetPagedOrderQuery.OrderStatusEnumEnum.Unpaid, GetPagedOrderQuery.OrderStatusEnumEnum.PartiallyPaid],
        orderItemStatusEnum: [GetPagedOrderQuery.OrderStatusEnumEnum.Unpaid, GetPagedOrderQuery.OrderStatusEnumEnum.PartiallyPaid,],
        startDate: shiftStartDate,
        endDate: dayjs(new Date()).endOf('day').toString(),
        pageRequest: {
          page: 0,
          size: 9999,
          orders: [{direction: 'DESC', property: 'creationTime'}],
        },
      })
      .subscribe((res) => {

        res.content.forEach((item)=> {
          console.log(item);
        });
        this.unpaidOrders = (res.content as OrderReq[]).map(order => ({
          ...order,
          orderItems: order.orderItems.flatMap(item =>
            Array.from({length: item.quantity - item.paidQuantity}, (_, quantityIndex) => ({
              ...item,
              order: {id: order.id},
              netAmount: (item.subtotal) / (item.quantity),
              tempQty: 1,
              selected: false,
              tempId: `${item.id}_${quantityIndex + 1}`
            }))
          )
        })) as ExtendedOrder[];

        this.loadUnpaidOrders$.next(this.unpaidOrders);
      });
  }

  toggleItemSelection(orderIndex: number, itemIndex: number) {
    this.unpaidOrders[orderIndex].orderItems[itemIndex].selected = !this.unpaidOrders[orderIndex].orderItems[itemIndex].selected;
  }

  isItemSelected(orderIndex: number, itemIndex: number): boolean {
    return this.unpaidOrders[orderIndex].orderItems[itemIndex].selected;
  }

  toggleRowSelection(orderIndex: number) {
    this.unpaidOrders[orderIndex].orderItems.forEach(item => {
      item.selected = !item.selected;
    });
  }

  getOrdersWithSelectedItems(): ExtendedOrder[] {
    const ordersWithSelectedItems: ExtendedOrder[] = [];

    this.unpaidOrders.forEach(order => {
      const selectedItems = order.orderItems.filter(item => item.selected);
      if (selectedItems.length > 0) {
        ordersWithSelectedItems.push({ ...order, orderItems: selectedItems });
      }
    });

    return ordersWithSelectedItems;
  }


  submit() {
    const ordersWithSelectedItems = this.getOrdersWithSelectedItems();
    const combinedItemsMap = new Map<number, ExtendedOrderItems>();

    ordersWithSelectedItems.forEach(order => {
      order.orderItems.forEach(orderItem => {
        // Check if the item is selected
        if (orderItem.selected) {
          const existingItem = combinedItemsMap.get(orderItem.id);
          if (existingItem) {


          } else {
            combinedItemsMap.set(orderItem.id, { ...orderItem });
          }
        }

      });
    });

    // Convert map values back to an array of items
    const combinedItems = Array.from(combinedItemsMap.values());

    // Update orderItems with combined items
    ordersWithSelectedItems.forEach(order => {
      order.orderItems = order.orderItems.filter(orderItem => !orderItem.selected).concat(combinedItems);

      order.orderItems = order.orderItems.filter(item => {
        return item.order.id === order.id;
      });

    });

    console.log(ordersWithSelectedItems);
    this.printBill(ordersWithSelectedItems);
    // this.dialogRef.close({
    //   selectedPaidOrder: ordersWithSelectedItems,
    // });
  }

  checkIfSelectItem(){
    if(this.unpaidOrders){
      for (const order of this.unpaidOrders) {
        for (const item of order.orderItems) {
          if (item.selected) {

            return false;
          }
        }
      }

    }

    return true;
  }

  printBill(ordersWithSelectedItems: ExtendedOrder[]) {
    let posId = this.ls.getPosId();
    for (let mvp of this.merchant.merchantVsPrinters.filter(x => x.posId === posId || !x.posId)) {
      if (mvp.printOrderReceiptForCustomer) {
        this.customPaymentService.getCustomerOrderReceipt(
          this.tableMerchant.id,
          ordersWithSelectedItems,
          mvp.printer.paperSizeType == 'BIG' ? 45 : 32,
          (res) => {
            printz(
              {
                printerName: mvp.printer.printerName,
                printerType: mvp.printer.printerType,
                vendorId: mvp.printer.printerVendorId,
                ipAddress: mvp.ipAddress,
                macAddress: mvp.macAddress,
              },
              [res]
            );
          }
        );
      }
    }
  }
}
